module.exports = __webpack_public_path__ + "static/media/Nach_of_bank.2b5d6002.svg";